<template>
  <div class="calculator-wrapper">
    <div class="calculator">
      <CalculatorHeading :step="step"></CalculatorHeading>
      <SelectMultipleInput
        :question="$t('multimedia.question')"
        :image="require('@/assets/projector.jpg')"
        :selections="selections"
        :clicked-callback="onSelect"
        :next="next"
      ></SelectMultipleInput>
      <a
        @click="$router.push(getPrevStepUrl(step, $i18n.locale))"
        class="back-btn"
        >{{ $t("back") }}</a
      >
    </div>
  </div>
</template>

<script>
  import {mapMutations} from "vuex";
  import CalculatorHeading from "../../components/CalculatorHeading";
  import {getStepIndex} from "@/utils/steps.js";
  import {getPrevStepUrl, goToNextStep, redirectToUnselectedStepIfAny} from "../../utils/steps";
  import SelectMultipleInput from "../../components/SelectMultipleInput";

  export default {
  name: "Multimedia",
  components: { SelectMultipleInput, CalculatorHeading },
  data() {
    return {
      step: getStepIndex("multimedia"),
      getPrevStepUrl: getPrevStepUrl,
      selections: [
        {
          name: this.$t("multimedia.projector-screen"),
          selected: this.$store.state.data.projectorScreen,
          update: value => this.updateProjectorScreen(value)
        },
        {
          name: this.$t("multimedia.sonos"),
          selected: this.$store.state.data.sonos,
          update: value => this.updateSonos(value)
        }
      ]
    };
  },
  mounted() {
    redirectToUnselectedStepIfAny(
      this.step,
      this.$store.state.data,
      this.$router,
      this.$i18n.locale
    );
  },
  methods: {
    ...mapMutations(["updateProjectorScreen", "updateSonos"]),
    onSelect(selection) {
      selection.update(!selection.selected);
      selection.selected = !selection.selected;
    },
    next() {
      goToNextStep(this.step, this.$i18n.locale, this.$router);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../common/_variables.scss";
h4 {
  color: $color-primary;
}
.back-btn {
  margin-top: 60px;
}
</style>
